import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Form from 'react-bootstrap/Form';

import { addCommitteeMember, removeCommitteeMember } from '../../redux/actions/boardMemberActions';
import SpinnerV2 from '../Spinner/Spinner';
import classes from './CommitteeAssignmentsForm.module.css';

const CommitteeAssignmentsForm = ({boardMemberId}) => {
  const boardMembers = useSelector(state => state.boardMembers)
  const dispatch = useDispatch();
  const [boardMember, setBoardMember] = useState(null);
  
  useEffect(() => {
    const bmIx = boardMembers.board_members.findIndex((bm) => {
      if (bm.id === boardMemberId) {
        return true;
      } else {
        return false;
      }
    })
    if (bmIx >= 0) {
      setBoardMember({...boardMembers.board_members[bmIx]});
    }
  }, [])
  const isMemberOfCommittee = (boardMember, committee) => {
    let isMember = false;
    boardMember.committees.forEach((c) => {
      if (c.id === committee.id) {
        isMember = true;
      }
    })
    return isMember;
  }

  const handleCheck = (committee, boardMember) => {
    //TODO: toggle committee for boardMember
    // alert(`Toggle Committee ${committee.name} for BM: ${boardMember.name}`)
    if (isMemberOfCommittee(boardMember, committee)) {
      dispatch(removeCommitteeMember(committee.id, boardMember.user_id))
    } else {
      dispatch(addCommitteeMember(committee.id, boardMember.user_id, false))
    }
  }

  const generateCommittees = (boardMember) => {
    const checkBoxes = boardMembers.committees.map((committee) => {
      return (
          <Form.Check
            type="checkbox"
            id={`${committee.id}-${committee.name}`}
            key={`${committee.id}-${committee.name}`}
            value={committee.id}
            label={committee.name}
            checked={isMemberOfCommittee(boardMember, committee)}
            onChange={() => handleCheck(committee, boardMember)}
            className={classes.FormCheck}
          />
      )
    })
    return checkBoxes;
  }

  if (boardMember === null) {
    return (
      <SpinnerV2 title="Getting board member" />
    )
    // alert('NO BOARD MEMBER')
    // return null;
  }
  return (
    <div>
      <div className={classes.FormTitle}>Committee assignments for {boardMember.name}</div>
    <Form>
      {generateCommittees(boardMember)}
    </Form>
    </div>
  );
}

export default CommitteeAssignmentsForm;